import React from "react";
import C3Chart from "react-c3js";
import clientService from "../../../services/client";
import ChartDateRangeForm from "./ChartDateRangeForm";
import AnalyticsChartCard from "./AnalyticsChartCard";
import {
  defaultStartDate,
  timeToAnswerAxis,
  formatHourLabel,
} from "./chartUtils";

const emptyChart = {
  x: "x",
  columns: [["x"], ["Total chats"]],
};

export default class QueueDropsChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: defaultStartDate(),
      endDate: new Date(),
      chartData: emptyChart,
    };
  }

  componentDidMount() {
    this.fetchData(this.state.startDate, this.state.endDate);
  }

  async fetchData(startDate, endDate) {
    let chartData = emptyChart;
    try {
      const res = await clientService.getQueueDrops(startDate, endDate);
      if (res.statusCode === 200 && res.data && res.data.length > 0) {
        const myData = res.data.filter((el) => el.hour > 7 && el.hour < 22);
        chartData = {
          x: "x",
          columns: [
            ["x", ...myData.map((m) => formatHourLabel(m.hour))],
            ["Total chats", ...myData.map((m) => m.count)],
          ],
        };
      }
    } catch (err) {
      console.error(err);
    }
    this.setState({ chartData });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.fetchData(this.state.startDate, this.state.endDate);
  };

  render() {
    return (
      <React.Fragment>
        <ChartDateRangeForm
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          onStartChange={(date) => this.setState({ startDate: date })}
          onEndChange={(date) => this.setState({ endDate: date })}
          onSubmit={this.handleSubmit}
          layout="compact"
        />
        <AnalyticsChartCard
          title=" Queue Drops "
          cardClassName="box-3rd card card101"
        >
          <C3Chart
            size={{ height: 500 }}
            padding={{ left: 100, right: 50 }}
            data={this.state.chartData}
            legend={{ show: true }}
            axis={timeToAnswerAxis}
          />
        </AnalyticsChartCard>
      </React.Fragment>
    );
  }
}
